import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { reportError } from "@/lib/errorReporting";

window.addEventListener('error', (event) => {
  reportError({
    error_message: event.message || 'Error de JavaScript no controlado',
    stack_trace: event.error?.stack || null,
    endpoint: window.location.pathname,
    extra_context: { filename: event.filename, lineno: event.lineno, colno: event.colno },
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  reportError({
    error_message: reason?.message || String(reason) || 'Promise rechazada sin manejar',
    stack_trace: reason?.stack || null,
    endpoint: window.location.pathname,
    extra_context: { type: 'unhandledrejection' },
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
